import { createAction, props } from '@ngrx/store';
import { Summary } from '@octiga/microsoft-events/src/interfaces/summary.interface';

export const loadSummaries = createAction(
    '[Root/Summary/API] Load Summarys',
    props<{ _tenant: string; num_days: number }>(),
);

export const loadSummariesByStartEnd = createAction(
    '[Root/Summary/API] Load Summaries By Start End',
    props<{ _tenant: string; start: string; end: string }>(),
);

export const upsertSummaries = createAction(
    '[Root/Summary/API] Upsert Summaries',
    props<{ _tenant: string; summaries: Summary[]; num_days?: number }>(),
);

export interface RecalculateRequest {
    start: string;
    end: string;
}

export const recalculateSummaries = createAction(
    '[Root/Summary/API] Recalculate Summaries',
    props<{ _tenant: string; dates: RecalculateRequest[] }>(),
);

export const recalculateSummariesSuccess = createAction(
    '[Root/Summary/API] Recalculate Summaries Success',
    props<{ _tenant: string }>(),
);

export const recalculateSummariesFailure = createAction(
    '[Root/Summary/API] Recalculate Summaries Failure',
    props<{ _tenant: string; error: any }>(),
);
